import { render, staticRenderFns } from "./ordersOverviewPaymentTypeTable.vue?vue&type=template&id=2a6fba83&"
import script from "./ordersOverviewPaymentTypeTable.vue?vue&type=script&lang=ts&"
export * from "./ordersOverviewPaymentTypeTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports